import React, { useEffect, useRef, useState } from "react";
import { useBox } from "../Helper/useBox";
import { GetKey } from "../Actions/GetContainer";
import { useForm } from "../Helper/useForm";
import { BoxFiltros2 } from "../Helper/BoxFiltros2";
import request from "../../../Helpers/API";
import { GastosConsolidados } from "../Actions/GastosConsolidados";
import { GastosByTipoScren } from "../Actions/GastosByTipoScren";
import { ArrayTotalizarByProp } from "../Actions/TotalizarProps";
import { FormatMoney } from "../../../Helpers/FormatNumber";
import { GetTipoGasto } from "../Helper/GetTipoGasto";
import { LoaderScreen } from "../../components/LoaderScreen";
import { GetPeriodo } from "../Actions/GetContainer";
import {
  GetFechaActual,
  GetFechaActualAnterior,
  formatoFecha,
} from "../Actions/ActionEstadoResultados";
import Swal from "sweetalert2";
import { useHistory, useLocation } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { GetMonthNameByNumber } from "../Helper/GetMonthNameByNumber";
import { FiltroGastos } from "../Helper/FiltroGastos";
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import { AyudaModal } from "./AyudaModal";

export const GastosScreen = () => {
  const history = useHistory();
  const [tituloPlantilla, setTituloPlantilla] = useState("GASTOS");
  const location = useLocation();
  const permisos = location.state;
  const [nomEscenario, setNomEscenario] = useState("");
  const [subtitulo, setSubtitulo] = useState("Escenario 1");
  const helpRef = useRef(null);
  const [openHelp, setOpenHelp] = useState(false);
  const idSucursalUnicos = [
    ...new Map(
      permisos.map((item) => [item.idsucursal, { idsucursal: item.idsucursal }])
    ).values(),
  ];
  const idDepartamentoUnicos = [
    ...new Map(
      permisos.map((item) => [
        item.iddepartamento,
        { iddepartamento: item.iddepartamento },
      ])
    ).values(),
  ];
  const storedState =
    JSON.parse(localStorage.getItem("dashboard_filtro")) || {};
  const onHome = () => {
    history.push("/Finanzas/Main");
  };
  const fechaActual = new Date();
  const ejercicioActual = fechaActual.getFullYear();
  const mesActual = fechaActual.getMonth() + 1;
  const [boxstate, setBoxState, updateBoxState] = useBox({
    ejercicio: storedState.ejercicio || 0,
    mesInicio: storedState.periodoinicio || 1,
    mesFin: storedState.periodofin || 0,
    ejercicioinicio: storedState.ejercicio || ejercicioActual,
    periodoinicio: storedState.periodoinicio || "1",
    ejerciciofin: storedState.ejercicio || ejercicioActual,
    periodofin: storedState.periodofin || mesActual,
    arraysucursal: [],
    comparacion: 'R',
    escenario: 'A',
    arraydepartamento: [],
    pv: { adr: [], sucursal: [], departamento: [] },
  });
  const [totales, setTotales] = useState({
    real: 0,
    proyeccion: 0,
    porc: 0,
    diferencia: 0,
    realant: 0,
    porcant: 0,
    diferenciaant: 0,
  });

  const [titulo, setTitulo] = useState({
    tipogasto: "",
    subtitulo: "",
    mesinicio: 0,
    ejercicio: 0,
    adr: "",
    sucursal: "",
    departamento: "",
    fechainicio: "",
    fechafin: "",
    periodoinicio: "0",
    periodofin: "0",
    ejercicioinicio: "0",
    ejerciciofin: "0",
    comparacion: "R",
  });


  const [state, setState] = useState({
    subtitulo: "",
    data: [],
    periodoactual: "",
    periodoanterior: "",
  });
  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });

  const [value, changeValue] = useForm({ tipogasto: "C" });
  const BoxClick = () => {
    return new Promise((res, req) => {
      setLoader({ ...loader, mostrar: true });
      if (
        boxstate.ejercicioinicio === undefined ||
        boxstate.ejercicioinicio === null ||
        boxstate.ejercicioinicio === "" ||
        boxstate.ejercicioinicio === "0" ||
        boxstate.ejercicioinicio === 0
      ) {
        req("Favor de agregar el ejercicio de inicio");
        setLoader({ ...loader, mostrar: false });
        return;
      }
      if (
        boxstate.periodoinicio === undefined ||
        boxstate.periodoinicio === null ||
        boxstate.periodoinicio === "" ||
        boxstate.periodoinicio === "0" ||
        boxstate.periodoinicio === 0
      ) {
        req("Favor de agregar el periodo de inicio");
        setLoader({ ...loader, mostrar: false });
        return;
      }
      if (
        boxstate.ejerciciofin === undefined ||
        boxstate.ejerciciofin === null ||
        boxstate.ejerciciofin === "" ||
        boxstate.ejerciciofin === "0" ||
        boxstate.ejerciciofin === 0
      ) {
        req("Favor de agregar el ejercicio fin");
        setLoader({ ...loader, mostrar: false });
        return;
      }
      if (
        boxstate.periodofin === undefined ||
        boxstate.periodofin === null ||
        boxstate.periodofin === "" ||
        boxstate.periodofin === "0" ||
        boxstate.periodofin === 0
      ) {
        req("Favor de indicar el periodo final");
        setLoader({ ...loader, mostrar: false });
        return;
      }

      const fechainicio = new Date(
        boxstate.ejercicioinicio,
        Number(boxstate.periodoinicio) - 1,
        "01"
      );
      const fechafin = new Date(
        boxstate.ejerciciofin,
        Number(boxstate.periodofin) - 1,
        "01"
      );
      const postC = {
        fechainicio,
        fechafin,
        escenario: boxstate.escenario,
        adr: GetKey(boxstate.pv.adr, ["idadr"]),
        sucursales:
          GetKey(boxstate.pv.sucursal, ["idsucursal"]) || '0',
        // GetKey(idSucursalUnicos, ["idsucursal"]),
        departamento:
          GetKey(boxstate.pv.departamento, ["iddepartamento"]) || '0',
        // GetKey(idDepartamentoUnicos, ["iddepartamento"]),
        tipo: value.tipogasto,
      };
      const postP = {
        ejercicio: Number(boxstate.ejercicioinicio),
        ejercicioant: Number(boxstate.ejerciciofin),
        escenario: boxstate.escenario,
        comparar: boxstate.comparacion,
        Periodo: GetPeriodo(boxstate.periodoinicio, boxstate.periodofin),
        departamento: GetKey(boxstate.pv.departamento, ["iddepartamento"]) || '',
        sucursal: GetKey(boxstate.pv.sucursal, ["idsucursal"]) || '0',
        adr: GetKey(boxstate.pv.adr, ["idadr"]),
      };
      const endpoint =
        value.tipogasto === "C"
          ? "FEGastos_Concepto/GastosvsProyeccionbyTiempo"
          : "ProyeccionesGastos/Obtener";
      const post =
        value.tipogasto === "C"
          ? postC
          : postP;
      request
        .post(endpoint, post)
        .then((result) => {
          // console.log(result)
          setLoader({ ...loader, mostrar: false });
          // setState({ ...state,  });
          setTitulo({
            tipogasto: value.tipogasto,
            fechainicio,
            fechafin,
            periodoinicio: boxstate.periodoinicio,
            periodofin: boxstate.periodofin,
            ejercicioinicio: boxstate.ejercicioinicio,
            ejerciciofin: boxstate.ejerciciofin,
            comparacion: boxstate.comparacion === "R" ? "REAL" : "PROYECTADO",
          });
          res("");

          if (
            String(boxstate.periodoinicio) === String(boxstate.periodofin) &&
            String(boxstate.ejercicioinicio) === String(boxstate.ejerciciofin)
          ) {
            setTituloPlantilla(
              `GASTOS ${GetMonthNameByNumber(
                boxstate.periodoinicio
              ).toUpperCase()} ${boxstate.ejercicioinicio}`
            );
          } else {
            setTituloPlantilla(
              `GASTOS ${GetMonthNameByNumber(
                boxstate.periodoinicio
              ).toUpperCase()} ${boxstate.ejercicioinicio
              } - ${GetMonthNameByNumber(boxstate.periodofin).toUpperCase()} ${boxstate.ejerciciofin
              }`
            );
          }
          setSubtitulo(nomEscenario);
          // console.log(result)
          setState({
            ...state,
            data: result,
            subtitulo: `De ${formatoFecha(fechainicio)} al ${formatoFecha(
              fechafin
            )}`,
            periodoactual: GetFechaActual(
              boxstate.ejercicioinicio,
              boxstate.ejerciciofin,
              boxstate.periodoinicio,
              boxstate.periodofin
            ),
            periodoanterior: GetFechaActualAnterior(
              boxstate.ejercicioinicio,
              boxstate.ejerciciofin,
              boxstate.periodoinicio,
              boxstate.periodofin
            ),
          });
        })
        .catch((err) => {
          if (typeof err == Array) {
            req("Error al establecer conexion con el servidor");
            setLoader({ ...loader, mostrar: false });
          } else {
            req(err);
            setLoader({ ...loader, mostrar: false });
          }
          setState({ ...state, data: [] });
        });

      //  setLoader({ ...loader, mostrar: false });
    });
  };
  useEffect(() => {
    const fechaActual = new Date();
    const ejercicioActual = fechaActual.getFullYear();
    const mesActual = fechaActual.getMonth() + 1;

    updateBoxState({
      ejercicio: boxstate.ejercicio || ejercicioActual,
      mesInicio: boxstate.mesInicio || 1,
      mesFin: boxstate.mesFin || mesActual,
    });
  }, []);

  // console.log(idSucursalUnicos)

  useEffect(() => {
    const fetchData = async () => {
      setLoader({ ...loader, mostrar: true });

      const fechaActual = new Date();
      const ejercicioActual = fechaActual.getFullYear();
      const mesActual = fechaActual.getMonth() + 1;

      const ejercicio = boxstate.ejercicio || ejercicioActual;
      const mesFin = boxstate.mesFin || mesActual;

      const fechainicio = new Date(ejercicio, 0, 1);
      const fechafin = new Date(ejercicio, mesFin - 1, 1);
      const post = {
        fechainicio,
        fechafin,
        escenario: boxstate.escenario,
        adr: GetKey(boxstate.pv.adr, ["idadr"]),
        sucursales:
          GetKey(boxstate.pv.sucursal, ["idsucursal"]) ||
          GetKey(idSucursalUnicos, ["idsucursal"]),
        departamento:
          GetKey(boxstate.pv.departamento, ["iddepartamento"]) ||
          GetKey(idDepartamentoUnicos, ["iddepartamento"]),
        tipo: "C",
      };
      try {
        const result = await request.post(
          "FEGastos_Concepto/GastosvsProyeccionbyTiempo",
          post
        );
        setTitulo({
          tipogasto: value.tipogasto,
          fechainicio,
          fechafin,
        });
        if (
          String(boxstate.periodoinicio) === String(boxstate.periodofin) &&
          String(boxstate.ejercicioinicio) === String(boxstate.ejerciciofin)
        ) {
          setTituloPlantilla(
            `GASTOS ${GetMonthNameByNumber(
              boxstate.periodoinicio
            ).toUpperCase()} ${boxstate.ejercicioinicio}`
          );
        } else {
          setTituloPlantilla(
            `GASTOS ${GetMonthNameByNumber(
              boxstate.periodoinicio
            ).toUpperCase()} ${boxstate.ejercicioinicio
            } - ${GetMonthNameByNumber(boxstate.periodofin).toUpperCase()} ${boxstate.ejerciciofin
            }`
          );
        }
        if (nomEscenario) {
          setSubtitulo(nomEscenario.toUpperCase());
        }
        setState({
          ...state,
          data: result,
          subtitulo: `De ${formatoFecha(fechainicio)} al ${formatoFecha(
            fechafin
          )}`,
          periodoactual: GetFechaActual(
            ejercicioActual,
            ejercicioActual,
            1,
            mesFin
          ),
          periodoanterior: GetFechaActualAnterior(
            ejercicioActual,
            ejercicioActual,
            1,
            mesFin
          ),
        });
      } catch (err) {
        Swal.fire("Error", "No se pudieron cargar los datos", "error");
        // console.log(err)
        setState({ ...state, data: [] });
      } finally {
        setLoader({ ...loader, mostrar: false });
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const real = ArrayTotalizarByProp(state.data, "total");
    const proyeccion = ArrayTotalizarByProp(state.data, "proyeccion");
    const diferencia = ArrayTotalizarByProp(state.data, "dif");
    const porc =
      proyeccion === 0 || diferencia === 0
        ? 0
        : (diferencia / proyeccion) * 100;
    const realant = ArrayTotalizarByProp(state.data, "oldtotal");
    const diferenciaant = ArrayTotalizarByProp(state.data, "olddif");
    const porcant =
      diferenciaant === 0 || realant === 0
        ? 0
        : (diferenciaant / realant) * 100;

    setTotales({
      real: FormatMoney(real),
      proyeccion: FormatMoney(proyeccion),
      porc: FormatMoney(porc),
      diferencia: FormatMoney(diferencia),
      realant: FormatMoney(realant),
      porcant: FormatMoney(porcant),
      diferenciaant: FormatMoney(diferenciaant),
    });
  }, [state.data]);
  const PDFDownloadButton = () => {
    setLoader({ ...loader, mostrar: true });
    const post = {
      data: state.data,
      subtitulo: state.subtitulo,
      periodoactual: state.periodoactual,
      periodoanterior: state.periodoanterior,
      region: boxstate.pv.adr,
      sucursal: boxstate.pv.sucursal,
      departamento: boxstate.pv.departamento,
    };
    request
      .post(`FEGastos_Concepto/ReportePDF`, post)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        const linkSource = `data:application/pdf;base64, ${result.documento}`;
        const downloadLink = document.createElement("a");
        const fileName = `${result.nombredocumento}.${result.extension}`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("GASTOS", JSON.stringify(error), "error");
      });
  };

  const onGeneraExcel = () => {
    setLoader({ ...loader, mostrar: true });
    const post = {
      data: state.data,
      subtitulo: state.subtitulo,
      periodoactual: state.periodoactual,
      periodoanterior: state.periodoanterior,
      region: boxstate.pv.adr,
      sucursal: boxstate.pv.sucursal,
      departamento: boxstate.pv.departamento,
    };


    const endpoint =
      value.tipogasto === "C"
        ? "FEGastos_Concepto/GenerarExcel"
        : "ProyeccionesGastos/PGConsolidadoExcel";


    if (value.tipogasto === "C") {
      request
        .post(endpoint, post)
        .then(({ documento, filename }) => {
          const linkSource = `data:application/vnd.ms-excel;base64,${documento}`;
          const downloadLink = document.createElement("a");
          const fileName = `${filename}.xlsx`;
          downloadLink.href = linkSource;
          downloadLink.download = fileName;
          downloadLink.click();
          setLoader({ ...loader, mostrar: false });
        })
        .catch((error) => {
          setLoader({ ...loader, mostrar: false });
          Swal.fire("CREDITO Y COBRANZA", JSON.stringify(error), "error");
        });
    }
    else {
      request
        .get(
          `ProyeccionesGastos/PGConsolidadoExcel?ejercicio=${boxstate.ejercicioinicio}&escenario=${boxstate.escenario}`,
        )
        .then(({ documento, filename }) => {
          const linkSource = `data:application/vnd.ms-excel;base64,${documento}`;
          const downloadLink = document.createElement("a");
          const fileName = `${filename}.xlsx`;
          downloadLink.href = linkSource;
          downloadLink.download = fileName;
          downloadLink.click();
          setLoader({ ...loader, mostrar: false });
        })
        .catch((err) => {
          setLoader({ ...loader, mostrar: false });
          Swal.fire("PROYECCION DE GASTOS", JSON.stringify(err), "error");
        });
    }

  };

  const capitalizeWords = (str) => {
    return str
      ? str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase())
      : "";
  };

  const getIndicadorClass = (indicador) => {
    switch (indicador) {
      case "V":
        return "indicador-verde";
      case "A":
        return "indicador-amarillo";
      case "R":
        return "indicador-rojo";
      default:
        return "";
    }
  };

  const limpiarNumero = (valor) => {
    if (typeof valor === "string") {
      return Number(valor.replace(/[^0-9.-]+/g, ""));
    }
    return Number(valor);
  };

  const getIndicador = (importe, proyectado) => {
    // console.log(importe, proyectado)
    if (!proyectado || proyectado === 0) return "";

    const diferencia = (1 + (importe - proyectado) / Math.abs(proyectado)) * 100;

    if (diferencia < 95) {
      return "V";
    } else if (diferencia <= 105) {
      return "A";
    } else {
      return "R";
    }
  };
  // console.log(value)
  return (
    <PlantillaScreen
      titulo={tituloPlantilla}
      className={"gastos-main-screen"}
      className_main={1}
    >
      <div className="gastos-screen-container-header">
        <LoaderScreen loader={loader} />
        <div className="gastos-screen-boxFiltros-container">
          <div className="gastos-contenedor-filtros">
            <div className="gastos-regresar" onClick={() => onHome()}>
              <ArrowBackIcon /> Regresar
            </div>
            <FiltroGastos
              boxState={boxstate}
              onBoxChange={setBoxState}
              BoxClick={BoxClick}
              sucursales={permisos}
              titulo_filtro="FILTRO"
              tipoGasto={value.tipogasto}
              setTipoGasto={changeValue}
              tieneEscenarios={true}
              onEscenarioChange={setNomEscenario}
            >
            </FiltroGastos>
          </div>
        </div>
        <div className="gastos-screen-botones-container">
          {state.data.length < 1 ? (
            <></>
          ) : (
            <>
              <button className="excel" onClick={() => onGeneraExcel()}>
                Excel
              </button>

              {value.tipogasto === "C" && (
                <button className="PDF" onClick={() => PDFDownloadButton()}>
                  PDF
                </button>
              )}
            </>
          )}

          <button
            className="ayuda"
            onClick={() => setOpenHelp(!openHelp)}
          >
            <HelpOutlineOutlinedIcon /> Ayuda
          </button>

          {openHelp && (
            <div className="popover-help">
              <div className="arrow"></div>

              <div className="popover-titulo">
                <div className="popover-header">
                  <div className="popover-header-titulo">{"Ayuda"}</div>
                </div>
                <div className="plantilla-screen-efecto">
                  <div className="plantilla-screen-efecto-bl"></div>
                  <div className="plantilla-screen-efecto-circle"></div>
                  <div className="plantilla-screen-efecto-br"></div>
                </div>
              </div>

              <p className="texto">
                Los siguientes indicadores están puntuados en base al gasto respecto al proyectado del mismo, quedando las ponderaciones de la siguiente manera:
              </p>

              <div className="indicadores">
                <div className="fila">
                  <span className="circulo verde"></span>
                  <span className="label-texto-asd">Menor al gasto proyectado</span>
                </div>

                <div className="fila">
                  <span className="circulo rojo"></span>
                  <span className="label-texto-asd">Mayor al gasto proyectado</span>
                </div>
              </div>
            </div>
          )}

        </div>
      </div>

      {titulo?.tipogasto === 'C' && (
        state?.data?.length > 0 ? (
          <>
            <div className="gastos-header">
              <div className="subtitulo">{subtitulo.toUpperCase()}</div>
            </div>
            <div className="comparativa-gastos-proyeccion-tipo-gastos-container">
              <div
                id="comparativa-gastos-proyeccion-tipo-gastos"
                className="scroll-4"
              // style={{ marginTop: 10 }}
              >
                <table
                  className="table-informacion-gastos"
                  cellSpacing={0}
                  // style={{ marginTop: 10 }}
                  id="tabla-sticky"
                >
                  <thead>
                    <tr>
                      <th className="bl sticky-col-h-30"></th>
                      <th className="sticky-col-h-30"></th>
                      <th colSpan={4} className="bl sticky-col-h-30">
                        {capitalizeWords(state.periodoactual)}
                      </th>
                      <th colSpan={4} className="bl sticky-col-h-30">
                        {capitalizeWords(state.periodoanterior)}
                      </th>
                    </tr>
                    <tr className="tr-down">
                      <th className="bl w-cuenta sticky-col-h-1"></th>
                      <th className="w-concepto sticky-col-h-1">Concepto</th>
                      <th className="bl w-importe sticky-col-h-1">
                        <div>Real</div>
                      </th>
                      <th className="sticky-col-h-1" >
                      </th>
                      <th className="w-importe sticky-col-h-1">
                        <div>Proyección</div>
                      </th>
                      <th className="w-importe sticky-col-h-1">%</th>
                      <th className="w-importe sticky-col-h-1">
                        <div>Dif</div>
                      </th>
                      <th className="bl w-importe sticky-col-h-1">
                        <div>Real</div>
                      </th>
                      {/* <th className="w-importe sticky-col-h-1">Proyección</th> */}
                      <th className="w-importe sticky-col-h-1">%</th>
                      <th className="w-importe sticky-col-h-1">
                        <div>Dif</div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <GastosConsolidados state={state} />
                    <tr style={{ fontWeight: "bold" }}>
                      <td
                        colSpan={2}
                        style={{
                          fontWeight: "bold",
                          textAlign: "right",
                          paddingRight: 10,
                        }}
                        className="bl"
                      >
                        TOTAL
                      </td>
                      <td className="ta-right">
                        {/* {FormatMoney(ArrayTotalizarByProp(state.data, "total"))} */}
                        {totales.real}
                      </td>
                      <td className="ta-right">
                        <span className={`indicador ${getIndicadorClass(getIndicador(limpiarNumero(totales.real), limpiarNumero(totales.proyeccion)))}`}></span>
                      </td>
                      <td className="ta-right">
                        {/* {FormatMoney(ArrayTotalizarByProp(state.data, "proyeccion"))} */}
                        {totales.proyeccion}
                      </td>
                      <td className="ta-right">{totales.porc}</td>
                      <td className="ta-right">
                        {/* {FormatMoney(ArrayTotalizarByProp(state.data, "dif"))} */}
                        {totales.diferencia}
                      </td>
                      <td className="ta-right">
                        {/* {FormatMoney(ArrayTotalizarByProp(state.data, "oldtotal"))} */}
                        {totales.realant}
                      </td>
                      {/* <td className="ta-right">
                  {FormatMoney(
                    ArrayTotalizarByProp(state.data, "oldproyeccion")
                  )}
                </td> */}
                      <td className="ta-right">{totales.porcant}</td>
                      <td className="ta-right br" style={{ paddingRight: 10 }}>
                        {/* {FormatMoney(ArrayTotalizarByProp(state.data, "olddif"))} */}
                        {totales.diferenciaant}
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div style={{ height: 100 }}></div>
              </div>
            </div>
          </>
        ) : (
          <div></div>
        )
      )}

      {titulo?.tipogasto === 'P' && (
        <>
          <div className="gastos-header">
            <div className="subtitulo">{subtitulo.toUpperCase()}</div>
          </div>
          <div
            id="comparativa-gastos-proyeccion-tipo"
            className="scroll-4"
            style={{ marginTop: 10 }}
          >
            {state.data === undefined ||
              state.data === null ||
              state.length === 0 ? (
              <div>No existen datos para mostrar </div>
            ) : (
              <table
                className="table-informacion-gastos"
                cellSpacing={0}
                style={{ marginTop: 10 }}
                id="tabla-sticky"
              >
                <thead>
                  <tr className="tr-encabezado1">
                    <th className="w-cuenta sticky-col-h-30">CUENTA</th>
                    <th className="w-concepto sticky-col-h-30">
                      <div>CONCEPTO</div>
                    </th>
                    <th className="w-importe sticky-col-h-30">
                      <div>{`PROYECCION ${titulo.ejercicioinicio}`}</div>
                    </th>
                    <th className="w-importe sticky-col-h-30">
                    </th>
                    <th className="w-importe sticky-col-h-30">
                      <div>{`${titulo.comparacion} ${titulo.ejerciciofin}`}</div>
                    </th>
                    <th className="w-importe sticky-col-h-30">
                      <div>DIFERENCIA</div>
                    </th>
                    <th className="w-importe sticky-col-h-30">%</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    style={{
                      fontWeight: "bold",
                      fontSize: 14,
                      letterSpacing: 1,
                      textAlign: "center",
                    }}
                  >
                    <td className="bl br" colSpan={7}>
                      Gastos Variables
                    </td>
                  </tr>
                  {state.data
                    .filter((x) => x.tipo === "V")
                    .map((item) => (
                      <tr>
                        <td className="bl">{item.cuenta}</td>
                        <td>{item.concepto}</td>
                        <td className="ta-right bl">{FormatMoney(item.proy)}</td>
                        <td className="ta-center">
                          <span className={`indicador ${getIndicadorClass(item.indicador)}`}></span>
                        </td>
                        <td className="ta-right pr-5 ">
                          {FormatMoney(item.total)}
                        </td>
                        <td className="ta-right bl">
                          {FormatMoney(item.diferencia)}
                        </td>
                        <td className="ta-right br pr-5 ">
                          {FormatMoney(item.por)} %
                        </td>
                      </tr>
                    ))}
                  <tr style={{ fontWeight: "bold", fontSize: 12 }}>
                    <td
                      colSpan={2}
                      style={{
                        fontWeight: "bold",
                        textAlign: "right",
                        paddingRight: 10,
                      }}
                      className="bl"
                    >
                      Total Gastos Variables
                    </td>
                    <td className="ta-right">
                      {FormatMoney(
                        ArrayTotalizarByProp(
                          state.data.filter((x) => x.tipo === "V"),
                          "proy",
                        ),
                      )}
                    </td>
                    <td className="ta-center">

                      <span className={`indicador ${getIndicadorClass(getIndicador(ArrayTotalizarByProp(
                        state.data.filter((x) => x.tipo === "V"),
                        "proy",
                      ), ArrayTotalizarByProp(
                        state.data.filter((x) => x.tipo === "V"),
                        "total",
                      )))}`}></span>

                    </td>

                    <td className="ta-right">
                      {FormatMoney(
                        ArrayTotalizarByProp(
                          state.data.filter((x) => x.tipo === "V"),
                          "total",
                        ),
                      )}
                    </td>
                    <td className="ta-right">
                      {FormatMoney(
                        ArrayTotalizarByProp(
                          state.data.filter((x) => x.tipo === "V"),
                          "diferencia",
                        ),
                      )}
                    </td>
                    <td className="ta-right br">
                      {FormatMoney(
                        (ArrayTotalizarByProp(
                          state.data.filter((x) => x.tipo === "V"),
                          "diferencia",
                        ) /
                          ArrayTotalizarByProp(
                            state.data.filter((x) => x.tipo === "V"),
                            "total",
                          )) *
                        100,
                      )}{" "}
                      %
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={7}></td>
                  </tr>

                  <tr
                    style={{
                      fontWeight: "bold",
                      fontSize: 14,
                      letterSpacing: 1,
                      textAlign: "center",
                    }}
                  >
                    <td className="bl br" colSpan={7}>
                      Gastos Fijos
                    </td>
                  </tr>
                  {state.data
                    .filter((x) => x.tipo === "F")
                    .map((item) => (
                      <tr>
                        <td className="bl">{item.cuenta}</td>
                        <td>{item.concepto}</td>
                        <td className="ta-right bl">{FormatMoney(item.proy)}</td>
                        <td className="ta-center">
                          <span className={`indicador ${getIndicadorClass(item.indicador)}`}></span>
                        </td>
                        <td className="ta-right pr-5 ">
                          {FormatMoney(item.total)}
                        </td>
                        <td className="ta-right bl">
                          {FormatMoney(item.diferencia)}
                        </td>
                        <td className="ta-right br pr-5 ">
                          {FormatMoney(item.por)} %
                        </td>
                      </tr>
                    ))}
                  <tr style={{ fontWeight: "bold", fontSize: 12 }}>
                    <td
                      colSpan={2}
                      style={{
                        fontWeight: "bold",
                        textAlign: "right",
                        paddingRight: 10,
                      }}
                      className="bl"
                    >
                      Total Gastos Fijos
                    </td>
                    <td className="ta-right">
                      {FormatMoney(
                        ArrayTotalizarByProp(
                          state.data.filter((x) => x.tipo === "F"),
                          "proy",
                        ),
                      )}
                    </td>
                    <td className="ta-center">
                      <span className={`indicador ${getIndicadorClass(getIndicador(ArrayTotalizarByProp(
                        state.data.filter((x) => x.tipo === "F"),
                        "proy",
                      ), ArrayTotalizarByProp(
                        state.data.filter((x) => x.tipo === "F"),
                        "total",
                      )))}`}></span>
                    </td>
                    <td className="ta-right">
                      {FormatMoney(
                        ArrayTotalizarByProp(
                          state.data.filter((x) => x.tipo === "F"),
                          "total",
                        ),
                      )}
                    </td>
                    <td className="ta-right">
                      {FormatMoney(
                        ArrayTotalizarByProp(
                          state.data.filter((x) => x.tipo === "F"),
                          "diferencia",
                        ),
                      )}
                    </td>
                    <td className="ta-right pr-5 br">
                      {FormatMoney(
                        (ArrayTotalizarByProp(
                          state.data.filter((x) => x.tipo === "F"),
                          "diferencia",
                        ) /
                          ArrayTotalizarByProp(
                            state.data.filter((x) => x.tipo === "F"),
                            "total",
                          )) *
                        100,
                      )}{" "}
                      %
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={7}></td>
                  </tr>
                  <tr style={{ fontWeight: "bold", fontSize: 12 }}>
                    <td
                      colSpan={2}
                      style={{
                        fontWeight: "bold",
                        textAlign: "right",
                        paddingRight: 10,
                      }}
                      className="bl"
                    >
                      Total
                    </td>
                    <td className="ta-right">
                      {FormatMoney(ArrayTotalizarByProp(state.data, "proy"))}
                    </td>
                    <td className="ta-center">
                      <span className={`indicador ${getIndicadorClass(getIndicador(
                        ArrayTotalizarByProp(state.data, "proy"), ArrayTotalizarByProp(state.data, "total")))}`}></span>
                    </td>
                    <td className="ta-right">
                      {FormatMoney(ArrayTotalizarByProp(state.data, "total"))}
                    </td>
                    <td className="ta-right">
                      {FormatMoney(ArrayTotalizarByProp(state.data, "diferencia"))}
                    </td>
                    <td className="ta-right pr-5 br">
                      {FormatMoney(
                        (ArrayTotalizarByProp(state.data, "diferencia") /
                          ArrayTotalizarByProp(state.data, "total")) *
                        100,
                      )}{" "}
                      %
                    </td>
                  </tr>
                </tbody>
              </table>
            )}
          </div>
        </>
      )}
    </PlantillaScreen>
  );
};
